// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.spacing[data-v-d60e7522] {\n  padding-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
